export const DUPLICATED_MAGS = [
  [34, 46],
  [35, 37]
];